// extracted by mini-css-extract-plugin
export default {"productCardsLayout":"ProductCards_productCardsLayout__PPWMD","productCardsStepArrow":"ProductCards_productCardsStepArrow__nVL2n"};